export default "__VITE_ASSET__CCLELX9t__"